import Vue from 'vue'
import VueRouter from 'vue-router'
import zhongbaoai from '../views/zhongbaoai/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    // redirect: "/zhongbaoai"
        name: 'zhongbaoai',
        component: zhongbaoai,
        // meta:{
        //     title: '中宝AI药师',
        //     keepAlive: false
        // }
  }
  // ,
  // {
  //   path: '/zhongbaoai',
  //   name: 'zhongbaoai',
  //   component: zhongbaoai
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
